<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="syringe flatbed icon"></i>
        <div class="content">
          New Item
        </div>
      </h2>
    </div>
    <!-- <div class="ui divider"></div> -->
    <br/>
    <br/>
    <div class="ui form" id="new-item-form">

      <h4 class="ui dividing header">
        Basic Infromation
      </h4>

      <div class="three required fields">
        <div class="field">
          <label for="name">{{ $t('name') }}</label>
          <div class="ui input">
            <input type="text"
                   :placeholder="$t('name')"
                   v-model="item.name"
                   name="name">
          </div>
        </div>
        <div class="field">
          <label for="unitMeasurement">Category</label>
          <select
            name="itemCategory"
            class="ui fluid dropdown"
            id="unit_measurement_select"
            v-model="item.item_category_id"
          >
            <option value="">Item Category</option>
            <option :value="itemCategory.id" v-for="itemCategory in itemCategories">
              {{ itemCategory.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label for="unitMeasurement">Unit Measurement</label>
          <select
            name="unitMeasurement"
            class="ui fluid dropdown"
            id="item_category_select"
            v-model="item.unit_measurement_id"
          >
            <option value="">Unit Measurement</option>
            <option :value="unitMeasurement.id" v-for="unitMeasurement in unitMeasurements">
              {{ unitMeasurement.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="field">
        <label>Description</label>
        <textarea
          rows="3"
          :placeholder="'Description'"
          v-model="item.description"
          name="description"
        />
      </div>
      <br/>

      <h4 class="ui dividing header">
        Stock Infromation
      </h4>

      <div class="field">
        <label for="code">Code</label>
        <div class="ui input">
          <input type="text"
                 :placeholder="'Code'"
                 v-model="item.real_code"
                 name="realCode">
        </div>
      </div>

      <div class="three fields">
        <div class="field">
          <label for="code">Down Quantity Limit</label>
          <div class="ui input">
            <input type="number"
                   :placeholder="'Down Quantity Limit'"
                   v-model="item.down_quantity_limit"
                   name="downQuantityLimit">
          </div>
        </div>
        <div class="required field">
          <label for="code">Unit Price</label>
          <div class="ui input">
            <input type="number"
                   :placeholder="'Unit Price'"
                   v-model="item.recommanded_unit_price"
                   name="unitPrice">
          </div>
        </div>
        <div class="required field">
          <label for="code">Temperature</label>
          <div class="ui input">
            <input type="number"
                   :placeholder="'Temperature'"
                   v-model="item.temperature"
                   name="temperature">
          </div>
        </div>
      </div>

      <br/>
      <br/>
      <!-- <div class="ui divider"></div> -->
      <div class="ui blue right floated submit button"
           style="background-color: #092442"
           :class="{disabled: isPressed}"
           @click="save()">
        Submit
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isPressed: false,
      item: {
        real_code: '',
        down_quantity_limit: null,
        name: '',
        description: '',
        recommanded_unit_price: null,
        temperature: null,
        item_size_id: null,
        unit_measurement_id: null,
        item_category_id: null
      },
      itemCategories: [],
      loading: true
    }
  },
  mounted () {
    this.$http.get('items/categories').then(response => {
      this.itemCategories = response.data
      this.loading = false
      this.initGUI()
    })
  },
  methods: {

    initGUI () {
      this.$nextTick(() => {
        $('#unit_measurement_select').dropdown()
        $('#item_category_select').dropdown()

        $.fn.form.settings.rules.inList = function (value, list) {
          return list.includes(value)
        }

        $('#new-item-form').form({
          inline: true,
          on: 'submit',
          fields: {
            name: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter suplier name.'
                }
              ]
            },
            temperature: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter a temperature for this item.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter valid quantity number.'
                }
              ]
            },
            unitPrice: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter a reference selling price for this item.'
                },
                {
                  type: 'decimal',
                  prompt: 'Please enter valid price.'
                }
              ]
            },
            unitMeasurement: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please choose unit measurement for this item.'
                },
                {
                  type: `inList[${window._.map(this.unitMeasurements, 'id')}]`,
                  prompt: 'Please choose valid option.'
                }
              ]
            },
            itemCategory: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please choose category for this item.'
                },
                {
                  type: `inList[${window._.map(this.itemCategories, 'id')}]`,
                  prompt: 'Please choose valid option.'
                }
              ]
            }

          }
        })
      })
    },
    save () {
      if ($('#new-item-form').form('is valid')) {
        this.isPressed = true
        this.$http.post('items', {
          clinic_id: this.getFromLocalStorage('clinicId'),
          item: this.item
        }).then(response => {
          this.navigateTo('Show_Item', { key: 'params', value: { id: response.data.id } })
        }).catch(() => {
          this.isPressed = false
        })
      }
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/items/NewItem.vue